import { GreenBelt, Header } from "components"
export const GreenWaveDisplay = () => {
 return (
  <div>
   <Header />
   <GreenBelt />
  </div>
 )
}
